import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_3 = { class: "cursor-pointer symbol symbol-30px symbol-md-40px" }
const _hoisted_4 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_5 = { class: "menu-item px-3" }
const _hoisted_6 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_9 = { class: "fw-bold text-muted text-hover-primary fs-7" }
const _hoisted_10 = { class: "svg-icon" }
const _hoisted_11 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_12 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_13 = { class: "svg-icon svg-icon-1" }

import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const user = computed(() => {
  return store.getters.currentUser;
});
const site_id = computed(() => {
  return user.value.site_id ? user.value.site_id : '';
});
const changeSite = (id) => {
  store.dispatch(Actions.UPDATE_SITE, id)
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          modelValue: _unref(site_id),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(site_id) ? (site_id).value = $event : null)),
          placeholder: "请选择站点",
          style: {"width":"160px"},
          onChange: changeSite
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).sites, (s) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: s.id,
                label: s.name,
                value: parseInt(s.id)
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(user).username), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(user).email ? _unref(user).email : _unref(user).mobile), 1)
            ]),
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, {
                src: "media/icons/duotune/arrows/arr065.svg",
                style: {"width":"24px","height":"24px"}
              })
            ])
          ])
        ])
      ]),
      _createVNode(KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}
}

})